module.exports = __webpack_public_path__ + "static/img/table-empty-image.92a28e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/table-empty-image.png
// module id = iFVp
// module chunks = 9